export default __webpack_public_path__ + "static/media/Sebitse.cfc4fad1.JPG";